<template>

    <m-edit1/>

    <m-single-product-305 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard309","relatedCourse":false,"galleryFullSlider":false,"chatAvailable":true,"requestOrder":false,"showLatestOrderFromProduct":true,"showUserCellphone":true,"showViewCount":true,"decreaseChargeFromProductOwnerWallet":true},...{}}' :style='""' class="container my-3 single-product" >
                <template #p-1>   </template>
                </m-single-product-305>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct305 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct305';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct305 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
